import { render, staticRenderFns } from "./TaxIncentivesPage.vue?vue&type=template&id=bcb38c60&scoped=true"
import script from "./TaxIncentivesPage.vue?vue&type=script&lang=js"
export * from "./TaxIncentivesPage.vue?vue&type=script&lang=js"
import style0 from "./TaxIncentivesPage.vue?vue&type=style&index=0&id=bcb38c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb38c60",
  null
  
)

export default component.exports